import clsx from "clsx";
import { CardModalProps } from "../CardModal/CardModal";
import { Col, createModal, Typography, useTheme } from "@commonlibs";
import CardNavigationModal from "../CardNavigationModal/CardNavigationModal";
import { useTranslate } from "ui/locale";
import ButtonLink from "ui/router/components/ButtonLink/ButtonLink";

export interface WarningToExternalLinkModalProps extends CardModalProps {
    to: string;
}

const WarningToExternalLinkModal = createModal<WarningToExternalLinkModalProps>(({ className, to, close, ...rest }) => {
    const translate = useTranslate();
    const { spacing } = useTheme();
    return (
        <CardNavigationModal
            header={{ left: "close", onLeftClick: close, title: translate("LeaveToApp").toUpperCase() }}
            divider
            css={{ height: "60%" }}
            className={clsx("external-link-modal", className)}
            {...rest}
        >
            <Col gap={spacing["6"]}>
                <Typography variant="body2Regular" css={{ textAlign: "center" }}>
                    {translate("externalLinkModalText")}
                </Typography>
                <Typography variant="body2Regular" css={{ textAlign: "center" }}>
                    {translate("externalLinkModalText1")}
                </Typography>
                <Typography variant="body2Regular" css={{ textAlign: "center" }}>
                    {translate("externalLinkModalText2")}
                </Typography>
                <ButtonLink to={to} target="blank" label={translate("continue")} fullWidth Icon={false} />
            </Col>
        </CardNavigationModal>
    );
});

export default WarningToExternalLinkModal;
